// Backstage Content -- NS/Tractie overrides (E6 follow-up).
//
// Source: node_modules/@backstage/core-components/dist/layout/Content/Content.esm.js
// JSS name: "BackstageContent"
// Class key targeted: root
//
// The default Backstage Content uses theme.spacing(1.5) horizontal padding
// (12px), which leaves the filter column and content of pages like /tools,
// /catalog and /notifications visually misaligned with the PageHeader
// title (which uses 24px horizontal padding from --ns-space-inset-l). We
// align them by setting the Content root horizontal padding to match the
// PageHeader, so the title above the page reads on the same vertical
// rule as the filters and table below it.

const contentBase = {
  root: {
    paddingLeft: 'var(--ns-space-inset-l, 24px) !important',
    paddingRight: 'var(--ns-space-inset-l, 24px) !important',
  },
};

export const BackstageContentLightOverrides = contentBase;
export const BackstageContentDarkOverrides = contentBase;
